/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ActiveSurveyForm = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        status: {
    type: 'number',
    isRequired: true,
},
        questions: {
    type: 'array',
    contains: {
        type: 'ResponseSurveyQuestion',
    },
    isRequired: true,
},
    },
};